import { createRouter, createWebHashHistory } from 'vue-router'
import { ElMessage } from 'element-plus'
import Home from '../views/Home.vue'
import Error from '../views/404.vue'
import Support from '../views/isSupport.vue'

const routes = [
  {
    path: '/home',
    name: 'home',
    component: Home
  }, {
    path: '/callpage',
    name: 'call',
    component: Home
  }, {
    path: '/error',
    name: 'error',
    component: Error
  }, {
    path: '/nosupport',
    name: 'nosupport',
    component: Support
  }, {
    path: '/',
    redirect: {
      name: 'error'
    }
  }, {
    path: '/:any(.*)',
    redirect: {
      name: 'error'
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === 'home') {
    if (to.query.userid && to.query.call && to.query.pick) {
      next()
    } else {
      ElMessage.error('ENTER ERROR')
      next({
        path: '/error'
      })
    }
  } else {
    next()
  }
})

export default router
